module.exports = __webpack_public_path__ + "img/achal_no.812beb0a.png";